import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./styles/pages/_landing.scss";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import MintPage from "./pages/MintPage";

const App = () => {
	useEffect(() => {
		AOS.init();
	}, []);

	return (
		<BrowserRouter>
			<Switch>
				<Route path="/" exact>
					<LandingPage />
				</Route>
				<Route path="/mint" exact>
					<MintPage />
				</Route>
			</Switch>
		</BrowserRouter>
	);
};

export default App;
